import React from 'react';
import { List, Datagrid, TextField, SingleFieldList, ChipField, Edit, required, Pagination, 
     EditButton, SimpleForm, TextInput, Create, DeleteButton, CloneButton, Toolbar,
     ReferenceManyField } from 'react-admin';

const SitePagination = props => <Pagination rowsPerPageOptions={[100, 50, 25, 10]} {...props} />;

export const SiteList = props => (
    <List {...props} pagination={<SitePagination />}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="sub_name" />
            <ReferenceManyField label="Courses" reference="tracks" target="site" allowEmpty perPage={1000}>
                <SingleFieldList>
                    <ChipField source="title" />
                </SingleFieldList>
            </ReferenceManyField>
            <EditButton />
            <DeleteButton mutationMode={"pessimistic"} />
            <CloneButton />
        </Datagrid>
    </List>
);

export const SiteEdit = props => (
    <Edit title={<SiteTitle />} {...props}>
        <SimpleForm toolbar={<Toolbar alwaysEnableSaveButton={true}/>}>
            <TextInput source="id" disabled />
            <TextInput source="name" validate={required()}/>
            <TextInput source="sub_name" validate={required()}/>
        </SimpleForm>
    </Edit>
);

export const SiteCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" validate={required()}/>
            <TextInput source="sub_name" validate={required()}/>
        </SimpleForm>
    </Create>
);

const SiteTitle = ({ record }) => {
    return <span>Site {record ? `"${record.name}"` : ''}</span>;
};